import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

interface AdminRouteProps {
  children: React.ReactNode;
}

const ADMIN_ROLES = ['owner', 'admin'] as const;

/**
 * AdminRoute — requires the authenticated user to hold an admin-level role.
 * Non-admin users are redirected to /jobs instead of seeing the page.
 * Must be nested inside a <ProtectedRoute> so isLoading/isAuthenticated are
 * already resolved before this component runs.
 *
 * Ref: GitHub issue #36, task S3
 */
export function AdminRoute({ children }: AdminRouteProps) {
  const { user } = useAuthStore();
  const location = useLocation();

  if (!user || !ADMIN_ROLES.includes(user.role as (typeof ADMIN_ROLES)[number])) {
    return <Navigate to="/jobs" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
